export { DefaultContentComponent } from './default-content/default-content.component';

